export const csrfHeaders = {
    [document.querySelector('meta[name="_csrf_header"]')?.getAttribute('content') || '']: document.querySelector('meta[name="_csrf"]')?.getAttribute('content') || '',
};
